<template>
  <div>
    <!-- 盒子 -->
    <div class="border_parent">
      <b-nav pills fill class="student-status-nav">
        <b-nav-item :active="query.graduationStatus === 0" @click="handleStatusChange(0)">在读学生</b-nav-item>
        <b-nav-item :active="query.graduationStatus === 1" @click="handleStatusChange(1)">已毕业学生</b-nav-item>
      </b-nav>
      <b-row class="el-row-inline">
        <b-col :cols="screenSize" class="teacher-card" v-for="item in teacherList" :key="item.id">
          <a class="border_link">
            <b-card class="el-card">
              <div class="content">
                <div class="content_left">
                  <el-image style="width: 100%; height: auto" :src="item.photoUrl" fit="cover">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline image-error-icon"></i>
                    </div>
                  </el-image>
                </div>
                <div class="content_right">
                  <div class="content_name">{{ item.name }}</div>
                  <div class="content_discri">{{ item.description }}</div>
                </div>
              </div>
            </b-card>
          </a>
        </b-col>
      </b-row>
      <b-row v-if="teacherList.length === 0">
        <b-col>
          <div class="empty-state">暂无{{ query.graduationStatus === 1 ? "已毕业" : "在读" }}学生</div>
        </b-col>
      </b-row>
      <b-row v-if="total > 0" type="flex" justify="center">
        <b-col>
          <div class="pagination">
            <b-pagination v-model="query.pageNum" :total-rows="total" :per-page="query.pageSize" :limit="3" align="center" size="sm" @input="handleCurrentChange">
              <template v-slot:first-text><span class="text-pag">First</span></template>
              <template v-slot:prev-text><span class="text-pag">Prev</span></template>
              <template v-slot:next-text><span class="text-pag">Next</span></template>
              <template v-slot:last-text><span class="text-pag">Last</span></template>
              <template v-slot:ellipsis-text>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </template>
              <template v-slot:page="{ page, active }">
                <b v-if="active">{{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";
export default {
  name: "Student",
  data() {
    return {
      requestUrl: {
        getPage: "/student/page",
      },
      query: {
        name: "",
        pageNum: 1,
        pageSize: 12,
        graduationStatus: 0,
      },
      total: 0,
      teacherList: [],
      screenSize: 3,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.checkScreenSize(); // 初始化时检测一次页面尺寸
    window.addEventListener("resize", this.checkScreenSize); // 监听页面尺寸变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize); // 移除页面尺寸变化监听
  },
  methods: {
    // 页面尺寸变化
    checkScreenSize() {
      if (window.innerWidth < 1000) {
        this.screenSize = 6;
      } else {
        this.screenSize = 4;
      }
    },
    // 获取列表数据
    getData() {
      request
        .get(this.requestUrl.getPage, {
          params: this.query,
        })
        .then((res) => {
          if (res.code === "200") {
            const records = res.data.records || [];
            const supportsGraduationStatus = records.some(
              (item) => item.graduationStatus !== undefined && item.graduationStatus !== null
            );

            // 兼容尚未升级的线上后端：旧接口没有毕业状态字段时，
            // 历史学生统一归入“在读学生”，避免两个栏目重复显示同一批数据。
            if (!supportsGraduationStatus && this.query.graduationStatus === 1) {
              this.teacherList = [];
              this.total = 0;
            } else {
              this.teacherList = records;
              this.total = res.data.total;
            }
          } else {
            this.$message.error("获取失败");
          }
        });
    },

    handleStatusChange(graduationStatus) {
      if (this.query.graduationStatus === graduationStatus) {
        return;
      }
      this.query.graduationStatus = graduationStatus;
      this.query.pageNum = 1;
      this.getData();
    },

    //详情
    linkNews(id) {
      this.$router.push({
        name: "details",
        query: {
          researcherId: id,
          type: "3",
        },
      });
    },

    //修改页
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize;
      this.getData();
    },
    //修改每页条数
    handleCurrentChange(pageNum) {
      this.query.pageNum = pageNum;
      this.getData();
    },
  },
};
</script>

<style scoped>
* {
  font: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei, Tohoma, Arial;
  color: #313131;
}

h3 {
  color: #333;
  padding: 0;
  margin: 0, 0, 5px, 0;
  font-weight: normal;
}
.teacher-card {
  padding-bottom: 10px;
}
.student-status-nav {
  margin-bottom: 20px;
  background-color: #f5f7fa;
}

.student-status-nav /deep/ .nav-link {
  border-radius: 0;
  color: #002d71;
  font-weight: bold;
}

.student-status-nav /deep/ .nav-link.active {
  background-color: #002d71;
  color: #fbc52c;
}
.empty-state {
  padding: 60px 0;
  color: #909399;
  text-align: center;
}
.text-pag {
  color: #002d71;
  font-weight: bold;
}

@media (max-width: 1000px) {
  .border_parent {
    width: 100%;
    margin: auto;
  }

  .content {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .content:hover {
    cursor: pointer;
  }

  .content_left {
    width: 50%;
    margin-right: 0px;
    float: left;
  }

  .content_right {
    width: 50%;
    display: flex;
    float: left;
    flex-direction: column;
    justify-content: center;
    padding-left: 1rem;
  }

  .content_name {
    font-size: medium;
    font-weight: bold;
  }

  .content_discri {
    font-size: smaller;
  }
}

@media (min-width: 1000px) and (max-width: 1205px) {
  .border_parent {
    width: 80%;
    margin: auto;
  }

  .content {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .content:hover {
    cursor: pointer;
  }

  .content_left {
    width: 70%;
    margin-right: 10px;
    float: left;
  }

  .content_right {
    width: 40%;
    display: flex;
    float: left;
    flex-direction: column;
    justify-content: center;
    padding-left: 1rem;
  }

  .content_name {
    font-size: medium;
    font-weight: bold;
  }

  .content_discri {
    font-size: smaller;
  }
}

@media (min-width: 1205px) {
  .border_parent {
    width: 80%;
    margin: auto;
  }

  .content {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .content:hover {
    cursor: pointer;
  }

  .content_left {
    width: 70%;
    margin-right: 10px;
    float: left;
  }

  .content_right {
    width: 40%;
    display: flex;
    float: left;
    flex-direction: column;
    justify-content: center;
    padding-left: 1rem;
  }

  .content_name {
    font-size: larger;
    font-weight: bold;
  }

  .content_discri {
    font-size: medium;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.el-row-inline {
  display: flex;
  flex-wrap: wrap;
}

.el-card {
  min-width: 100%;
  height: 100%;
  margin: 0 auto;
}

.image-error-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}

.border_link {
  text-decoration: none;
  pointer-events: none;
}
</style>
